import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TableViewDrawerService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpenSubject.asObservable();

  private drawerDataSubject = new BehaviorSubject<any>(null);
  drawerData$ = this.drawerDataSubject.asObservable();

  openDrawer(data?: any): void {
    if (data) {
      this.drawerDataSubject.next(data);
    }
    this.isOpenSubject.next(true);
  }

  updateDrawerData(updates: Partial<any>): void {
    const currentData = this.drawerDataSubject.getValue();
    if (currentData) {
      this.drawerDataSubject.next({
        ...currentData,
        ...updates,
      });
    } else {
      this.drawerDataSubject.next(updates);
    }
  }

  closeDrawer(): void {
    this.isOpenSubject.next(false);
  }

  toggleDrawer(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }
}
